import { render, staticRenderFns } from "./LendingMarketList.vue?vue&type=template&id=c8510a34&scoped=true&lang=pug&"
import script from "./LendingMarketList.vue?vue&type=script&lang=ts&"
export * from "./LendingMarketList.vue?vue&type=script&lang=ts&"
import style0 from "./LendingMarketList.vue?vue&type=style&index=0&id=c8510a34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8510a34",
  null
  
)

export default component.exports